import React from 'react';
import propTypes from 'prop-types';

import solventLogo from 'src/ui/assets/solvent-logo.svg';

// Centered-card chrome for the branded (Terra/Pay) auth pages. White-label
// hosts must never render this — they keep the legacy markup in each page.
export function AuthCardLayout({ children }) {
  return (
    <div className="auth-card-layout">
      <div className="auth-card">
        <img className="auth-card-logo" src={solventLogo} alt="Solvent" />
        {children}
      </div>
    </div>
  );
}

AuthCardLayout.propTypes = {
  children: propTypes.node.isRequired,
};
